<template>
  <placement-status
    class="whitespace-nowrap"
    :model="model.isPlacement ? model : model.placement"
  />
</template>

<script setup lang="ts">
import type { IOffer } from "@/models/funders";
import type { PropType } from "vue";

type Model = IOffer & {
  tracking: string | null;
  submission?: string;
  isPlacement: boolean;
};

defineProps({
  model: {
    type: Object as PropType<Model>,
    required: true,
  },
});
</script>
